export const RECAPTCHA_SCRIPT_SRC = 'https://www.google.com/recaptcha/api.js?render=explicit';
export const RECAPTCHA_SCRIPT_ID = 'recaptcha-api-script';

/**
 * Injects the Google reCAPTCHA API script once, on demand. It used to be a static tag in
 * app/index.html, which pulled the whole google.com origin into every page load even though the
 * widget only renders for web-link distributions with a configured site key (L1S-1618).
 */
export const loadRecaptchaScript = (): void => {
  if (typeof document === 'undefined') return;
  if (document.getElementById(RECAPTCHA_SCRIPT_ID)) return;

  const script = document.createElement('script');
  script.id = RECAPTCHA_SCRIPT_ID;
  script.src = RECAPTCHA_SCRIPT_SRC;
  // Dynamically inserted scripts are async by default; `defer` is ignored when async is set.
  script.async = true;
  document.head.appendChild(script);
};
